import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DataService } from './data.service';
import { Datasource, DataSourceStatus } from './datasource';

@Injectable({
  providedIn: 'root'
})
export class RatingService implements OnDestroy {
  dataService: DataService;
  dsRatingObjects: Datasource;

  private dsRatingObjectsSub: Subscription;

  private ratingObjectLists: any = [];

  constructor() {}

  public get ratingObjectsCount(): any {
    return this.ratingObjectLists.length;
  }

  public get ratingObjects(): any {
    return [...this.ratingObjectLists];
  }

  ngOnDestroy() {
    if (this.dsRatingObjectsSub) {
      this.dsRatingObjectsSub.unsubscribe();
    }

    if (this.dsRatingObjects) {
      this.dataService.deleteDatasource(this.dsRatingObjects);
    }
  }

  setDataService(dataService: DataService) {
    this.dataService = dataService;
    this.dsRatingObjects = this.dataService.addNewDatasource('DBQuery');
  }

  removeRatingObjectSub() {
    if (this.dsRatingObjectsSub) {
      this.dsRatingObjectsSub.unsubscribe();
    }
  }

  async loadRatingObjects(contractId: string) {
    return new Promise(async (resolve) => {
      this.removeRatingObjectSub();
      this.dsRatingObjects.reset();

      let criteria = { Procedure_Name: 'epx_getRatingObjects', contractID: contractId };

      this.dsRatingObjects.get(criteria, true, false);

      this.dsRatingObjectsSub = this.dsRatingObjects.status$
        .pipe(filter((status) => [DataSourceStatus.Ready, DataSourceStatus.Error].includes(status)))
        .subscribe((status) => {
          this.removeRatingObjectSub();
          switch (status) {
            case DataSourceStatus.Ready:
              let newRatingObjects = [];
              if (this.dsRatingObjects && this.dsRatingObjects.objectNodes.length > 0) {
                for (var s in this.dsRatingObjects.objectNodes) {
                  newRatingObjects.push(this.dsRatingObjects.objectNodes[s]);
                }
                this.ratingObjectLists = [...newRatingObjects];
              } else {
                this.ratingObjectLists = [];
              }
              break;
            case DataSourceStatus.Error:
              this.ratingObjectLists = [];
              break;
          }

          resolve(true);
        });
    });
  }
}
